import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "consentFormsWrapper",
  class: "flex-col view-wrapper"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "flex-col waiver" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_waiver_question = _resolveComponent("waiver-question")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_loader_display, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "back-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
          }),
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "page-title" }, "Waiver", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Please read thoroughly and select “I agree” at the bottom of each section.", -1))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { id: "waiverTop" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, "Section " + _toDisplayString(_ctx.currentSection) + " of " + _toDisplayString(_ctx.sectionCount), 1),
          (_ctx.forms[_ctx.currentForm].ConsentFormQuestions.length)
            ? (_openBlock(), _createBlock(_component_waiver_question, {
                form: _ctx.forms[_ctx.currentForm].ConsentFormQuestions[_ctx.currentQuestion],
                key: _ctx.currentForm + _ctx.currentQuestion,
                onOnAgree: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onWaiverAgree($event))),
                onOnSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmitForm($event))),
                getSignature: _ctx.currentSection == _ctx.sectionCount
              }, null, 8, ["form", "getSignature"]))
            : _createCommentVNode("", true)
        ])
      ]))
}